// extracted by mini-css-extract-plugin
export var body = "styles-mod--body--82fe9";
export var button = "styles-mod--button--89ca4";
export var formInner = "styles-mod--form-inner--c3834";
export var links = "styles-mod--links--bd636";
export var loginInfo = "styles-mod--login-info--a652e";
export var opened = "styles-mod--opened--31596";
export var sidePanel = "styles-mod--side-panel--5f04b";
export var subtitle = "styles-mod--subtitle--68817";